import { render, staticRenderFns } from "./PromotionBatchNew.vue?vue&type=template&id=6974b000&"
import script from "./PromotionBatchNew.vue?vue&type=script&lang=js&"
export * from "./PromotionBatchNew.vue?vue&type=script&lang=js&"
import style0 from "./PromotionBatchNew.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports